/**
 * @file components/shared/common/index.ts
 * @description Common 컴포넌트들의 Barrel Export (SSOT)
 *
 * 주요 기능:
 * 1. Common 컴포넌트들을 한 곳에서 export
 * 2. UI 컴포넌트들 (Form, Dialog, Badge, Tooltip)도 re-export하여 편의성 제공
 * 3. 모든 Badge와 Tooltip은 여기서만 import (SSOT 원칙)
 *
 * 사용 예시:
 * ```tsx
 * // SSOT: 모든 컴포넌트는 common에서만 import
 * import { 
 *   Badge, 
 *   BrandTooltip, 
 *   Tooltip, 
 *   TooltipTrigger, 
 *   TooltipContent,
 *   Form, 
 *   Dialog 
 * } from "@/components/shared/common";
 * ```
 */

// Common 컴포넌트들
export { BackButton } from "./BackButton";
export { Badge, badgeVariants } from "./Badge";
export type { BadgeProps, ProjectBadgeProps, GenericBadgeProps } from "./Badge";
export { BrandTooltip } from "./BrandTooltip";
export type { BrandTooltipProps } from "./BrandTooltip";
export { EmptyState } from "./EmptyState";
export { FeedbackWidget } from "./FeedbackWidget";
export { Spinner } from "./Spinner";
export { MaintenancePage } from "./MaintenancePage";
export { ServiceDisclaimer } from "./ServiceDisclaimer";
export { ThemeToggleBulb } from "./ThemeToggleBulb";

// UI 컴포넌트들 re-export (편의를 위해)
export {
  Form,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
  FormField,
  useFormField,
} from "@/components/shared/ui/form";

export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@/components/shared/ui/dialog";

export { RadioGroup, RadioGroupItem } from "@/components/shared/ui/radio-group";

// Tooltip 통합 export (SSOT)
export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "@/components/shared/ui/tooltip";
